import { Component, OnInit, Input } from '@angular/core';
import { Simulation, SimulationStatus } from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';

@Component({
  selector: 'app-simulation-status',
  templateUrl: './simulation-status.component.html',
  styleUrls: ['./simulation-status.component.scss']
})
export class SimulationStatusComponent implements OnInit {

  @Input()
  simulationId: number;
  @Input()
  showText: boolean;

  status: any;

  STATUS_MAPPER = STATUS_MAPPER;

  constructor(
    private simulationQuery: SimulationQuery
  ) { }

  ngOnInit(): void {
    this.simulationQuery.selectEntity(this.simulationId).subscribe(simulation => {
      if (simulation && simulation.status >= 0) {
        this.status = {
          icon: ICON_MAP.get(simulation.status),
          text: simulation.status_description,
          animated: simulation.status < 4
        };
      } else {
        this.status = DEFAULT;
      }
    });
  }
}

const ICON_MAP = new Map<number, string>([
  [SimulationStatus.WAITING, 'hourglass_empty'],
  [SimulationStatus.PROCESSING_ALGORITHM, 'hourglass_top'],
  [SimulationStatus.ALGORITHM_PROCESSED, 'hourglass_bottom'],
  [SimulationStatus.EXECUTING_POST_PROCESSING, 'fiber_manual_record'],
  [SimulationStatus.DONE, 'check_circle_outline'],
  [SimulationStatus.ERROR, 'error'],
  [SimulationStatus.DRAFT, 'edit_note']
]);

const DEFAULT = {
  icon: 'unpublished',
  text: 'Not saved',
  animated: false
};

const STATUS_MAPPER = {
  Waiting: $localize`Waiting`,
  'Processing Algorithm': $localize`Processing Algorithm`,
  'Algorithm Processed': $localize`Algorithm Processed`,
  'Executing post processing': $localize`Executing post processing`,
  Done: $localize`Done`,
  Draft: $localize`Draft`,
  Error: $localize`Error`,
};
